interface BrandProps {
  constantsVersion: string;
  onVersionClick?: () => void;
}

export function Brand({ constantsVersion, onVersionClick }: BrandProps) {
  const taxYear = constantsVersion.match(/v(\d{4})/)?.[1] ?? '2026';
  const badgeClass =
    'text-grain-gold text-xs font-semibold tracking-wider border border-grain-gold/50 px-2 py-0.5 rounded focus:outline-none focus:ring-2 focus:ring-grain-gold';
  const badgeLabel = `Tax year ${taxYear}, constants ${constantsVersion}. Click to see what's new.`;

  return (
    <header
      class="bg-hudson-navy text-white px-4 py-3 flex items-center justify-between"
      role="banner"
    >
      <span class="font-bold tracking-wide text-sm uppercase select-none">
        HUDSON BAY FINANCE
      </span>
      {onVersionClick ? (
        <button
          type="button"
          onClick={onVersionClick}
          class={`${badgeClass} hover:bg-grain-gold/10 transition-colors`}
          aria-label={badgeLabel}
        >
          TAX YR {taxYear}
        </button>
      ) : (
        <span
          class={badgeClass}
          aria-label={`Tax year ${taxYear}, constants ${constantsVersion}`}
        >
          TAX YR {taxYear}
        </span>
      )}
    </header>
  );
}
